"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const react = require("react");
const asyncRateLimiter = require("@tanstack/pacer/async-rate-limiter");
const reactStore = require("@tanstack/react-store");
const PacerProvider = require("../provider/PacerProvider.cjs");
function useAsyncRateLimiter(fn, options, selector = () => ({})) {
  const mergedOptions = {
    ...PacerProvider.useDefaultPacerOptions().asyncRateLimiter,
    ...options
  };
  const [asyncRateLimiter$1] = react.useState(
    () => new asyncRateLimiter.AsyncRateLimiter(fn, mergedOptions)
  );
  asyncRateLimiter$1.fn = fn;
  asyncRateLimiter$1.setOptions(mergedOptions);
  const state = reactStore.useStore(asyncRateLimiter$1.store, selector);
  return react.useMemo(
    () => ({
      ...asyncRateLimiter$1,
      state
    }),
    // omit `store` in favor of `state`
    [asyncRateLimiter$1, state]
  );
}
exports.useAsyncRateLimiter = useAsyncRateLimiter;
//# sourceMappingURL=useAsyncRateLimiter.cjs.map
